var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page noselect" },
    [
      _c("v-container", { attrs: { "grid-list-md": "" } }, [
        _c(
          "div",
          { staticClass: "text-left mt-7" },
          [
            _c("h2", [_vm._v("Impressum")]),
            _c("div", { staticClass: "spacer-15" }),
            _c("CmsBlock", { attrs: { blockName: "Impressum" } }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }